import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-go-to-download-location',
  templateUrl: './go-to-download-location.component.html',
  styleUrls: ['./go-to-download-location.component.scss']
})
export class GoToDownloadLocationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
